import React, { Component } from "react"

export default class RefundGuarantee extends Component {
  openModal = () => {
    const { textKeys } = this.props
    const data = {
      refundGuaranteeModalOpen: true,
      refundGuaranteeModalData: {
        h3: textKeys.refundGuaranteeModalHeadline,
        richText: textKeys.refundGuaranteeModalText,
      },
    }
    this.props.setDataToState(data)
    if (this.props.trackingFunction) this.props.trackingFunction()
  }

  render() {
    const { textKeys } = this.props
    if (!textKeys || !textKeys.refundGuaranteeText) return ""
    return (
      <div className={`deck deck--white ${this.props.useNewDesign ? "deck--padding-bottom-slim" : "deck--padding-bottom"}`}>
        <div className="w--wider">
          <div
            className={`refund-guarantee refund-guarantee--block ${this.props.modifier ? this.props.modifier : ""} ${
              this.props.useNewDesign ? "refund-guarantee--new" : ""
            }`}
          >
            {/* eslint-disable react/no-unknown-property */}
            {textKeys.refundGuaranteeImage ? (
              <img className="refund-image" src={textKeys.refundGuaranteeImage} loading="eager" fetchpriority="high" />
            ) : (
              ""
            )}
            {/* eslint-enable react/no-unknown-property */}

            <span className="refund-text" dangerouslySetInnerHTML={{ __html: textKeys.refundGuaranteeText }}></span>
            {textKeys.refundGuaranteeLinkText ? (
              <a className="modal-link" onClick={() => this.openModal()}>
                {textKeys.refundGuaranteeLinkText}
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    )
  }
}
